import { Box } from "@mui/system"
import { styled } from '@mui/material/styles';

const BoxFC = styled(Box, {skipSx:false})(({theme})=>({
    display: 'flex',
    flexDirection: "column",
    gap: theme.spacing(2),
}))

export default BoxFC